const FLAT_SHIPPING_RATE = 100;
const OK = "ok";
const ERROR = "error";
const UNAUTHORIZED = "Unauthorized";
const JWT_AUTH_VALID_TOKEN = "jwt_auth_valid_token";
const INTERNAL_SERVER_ERROR = "Internal server error";

const PAYTM_STATUS_CODES = {
  PENDING: "PENDING",
  TXN_FAILURE: "TXN_FAILURE",
  TXN_SUCCESS: "TXN_SUCCESS",
  NO_RECORD_FOUND: "NO_RECORD_FOUND",
};

const PAYMENT_STATUS_MAPPING = {
  PENDING: "pending",
  TXN_FAILURE: "failed",
  TXN_SUCCESS: "processing",
  NO_RECORD_FOUND: "pending",
};

const USER_ROLES = {
  DOCTOR: "doctor",
  CUSTOMER: "customer",
};

const POST_META_TYPE = {
  TAGS: "TAGS",
  AUTHOR: "AUTHOR",
  FEATURE_MEDIA: "FEATURE_MEDIA",
};

const BLOG_CATEGORY_DETAILS = {
  DISEASE_MANAGEMENT: {
    id: 328,
    order: 1
  },
  PRODUCT_INFORMATION: {
    id: 327,
    order: 2
  },
  AYURVEDA_WELLNESS: {
    id: 330,
    order: 3
  },
  RECENT_NEWS: {
    id: 331,
    order: 4
  },
};

module.exports = {
  OK,
  ERROR,
  USER_ROLES,
  UNAUTHORIZED,
  POST_META_TYPE,
  PAYTM_STATUS_CODES,
  FLAT_SHIPPING_RATE,
  JWT_AUTH_VALID_TOKEN,
  INTERNAL_SERVER_ERROR,
  BLOG_CATEGORY_DETAILS,
  PAYMENT_STATUS_MAPPING,
};
